module.exports = __webpack_public_path__ + "img/gestoCoracao.16738fee.png";